import React from 'react';
import type { PolicyTemplate } from '@abs/shared-types';
import { POLICY_TEMPLATES } from '@/data/policyTemplates';

export interface PolicyTemplateSelectorProps {
  onSelect: (template: PolicyTemplate) => void;
  onScratch: () => void;
}

export function PolicyTemplateSelector({ onSelect, onScratch }: PolicyTemplateSelectorProps): React.ReactElement {
  return (
    <div className="template-selector">
      <h4>Choose a Policy Template</h4>
      <div className="template-selector__grid">
        {POLICY_TEMPLATES.map((t) => (
          <button
            key={t.id}
            className="template-selector__card"
            onClick={() => onSelect(t)}
            type="button"
          >
            <span className="template-selector__name">{t.name}</span>
            <span className="template-selector__desc">{t.description}</span>
          </button>
        ))}
        <button className="template-selector__card template-selector__card--scratch" onClick={onScratch} type="button">
          <span className="template-selector__name">Start from Scratch</span>
          <span className="template-selector__desc">Configure your own policy manually</span>
        </button>
      </div>
    </div>
  );
}
